import { render, staticRenderFns } from "./ActivityWsConfirmationVideo.vue?vue&type=template&id=f82b5ee4&scoped=true"
import script from "./ActivityWsConfirmationVideo.vue?vue&type=script&lang=ts"
export * from "./ActivityWsConfirmationVideo.vue?vue&type=script&lang=ts"
import style0 from "./ActivityWsConfirmationVideo.vue?vue&type=style&index=0&id=f82b5ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82b5ee4",
  null
  
)

export default component.exports